import { get } from 'lodash';

import FilterDefinition from 'helpers/search_filters/filter_definition';
import MeasurementFormatter from '../../search_filters/formatters/measurement_formatter';

const buildSelector = path => query => get(query, `propertyFilter.${path}`);

export const buildingSize = new FilterDefinition({
  label: 'Building Size',
  type: FilterDefinition.types.range,
  formatter: new MeasurementFormatter(),
  minValue: buildSelector('minBuildingSize'),
  maxValue: buildSelector('maxBuildingSize'),
  unit: buildSelector('buildingSizeUnits')
});

export const lotSize = new FilterDefinition({
  label: 'Lot Size',
  type: FilterDefinition.types.range,
  formatter: new MeasurementFormatter(),
  minValue: buildSelector('minLotSize'),
  maxValue: buildSelector('maxLotSize'),
  unit: buildSelector('LotSizeUnits')
});

export const price = new FilterDefinition({
  label: 'Sale Price',
  type: FilterDefinition.types.range,
  minValue: buildSelector('minPrice'),
  maxValue: buildSelector('maxPrice')
});

export const units = new FilterDefinition({
  label: 'Units',
  type: FilterDefinition.types.range,
  minValue: buildSelector('minUnits'),
  maxValue: buildSelector('maxUnits')
});

export const leaseDate = new FilterDefinition({
  label: 'Lease Date',
  type: FilterDefinition.types.range,
  minValue: buildSelector('minLeaseDate'),
  maxValue: buildSelector('maxLeaseDate')
});

export default [
  buildingSize,
  lotSize,
  price,
  units,
  leaseDate
];
